var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("資料集管理")]), _c('div', {
    staticClass: "col-12 col-xl-6 d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_vm.checkPermission([_vm.consts.COLLECTION_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CollectionCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增資料表 ")]) : _vm._e(), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.collections,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [data.item.is_enabled == true ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" 啟用 ")]) : _vm._e(), data.item.is_enabled == false ? _c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" 停用 ")]) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.COLLECTION_ITEM_MANAGE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-success",
            "to": {
              name: 'CollectionItemList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 項目管理 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.COLLECTION_EDIT]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'CollectionEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.COLLECTION_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteCollection(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }